import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'
import Joyride, { CallBackProps, STATUS, Step } from 'react-joyride';
import ReactRoundedImage from "react-rounded-image";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import _, { set } from "lodash";
import BannerSection from './BannerSection';
import MainSection from './MainSection';
import {
    getBannerCardSummary, getBannerCardSummaryClear,
    getProfileCompletePercentage, getProfileCompletePercentageClear
} from '../redux/user/actions';
import { myCart } from '../redux/Cart/actions'
import { postEthicsAgreeCheck } from '../redux/courses/actions'
import { getCodeOfEthics, getCodeOfEthicsResponse } from "../redux/courses/actions";
import { getActiveHeader, homePageMsgClear, homePageShowMsg } from '../redux/home/actions'
import ShimmerBannerCard from './Layouts/ShimmerBannerCard';
import { SessionKeys, clickStreamUser } from '../utils/AppUtils';
import { setIsMembershipClear } from '../redux/membership/actions'

const HomeSection = ({ isLoading, setIsLoading }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation();

    const auth = useSelector(state => state.auth.auth)
    const authBroker = useSelector(state => state.auth.authBroker);
    const profilePercentData = useSelector(state => state.user.profilePercentageData);
    const checklistData = useSelector(state => state.courses.ethicsAgreeData);
    const bannerCard = useSelector(state => state.user.bannerCard)
    const isMembershipSucceed = useSelector(state => state.membership.isMembershipSucceed)
    const agreeResponse = useSelector(
        (state) => state.courses.ethicsAgreeData
    );
    const codeOfEthics = useSelector((state) => state.courses.ethicsData);
    const userRole = useSelector(state => state.user.role)
    const showHomePageMsg = useSelector(state => state.home.showHomePageMsg)
    const homePageMsg = useSelector(state => state.home.homePageMsg)
    const [ethicsData, setEthicsData] = useState([]);
    const [agreeRespData, setAgreeRespData] = useState([]);

    const [showTrailAlert, setShowTrailAlert] = useState(false);
    const [daysLeft, setdaysLeft] = useState(0);

    useEffect(() => {
       dispatch(getActiveHeader("home"));
    }, []);

    useEffect(() => {
        if (!_.isEmpty(authBroker)) {
            if (authBroker.status === 'success') {
                const authBrokerData = authBroker.payload?.user
                if (!_.isEmpty(authBrokerData)) {
                    if (authBrokerData.IsGuest) {
                        console.log("guest user- end date", authBrokerData?.guest_end_date);
                        const area = authBrokerData.timezoneAbbr ? authBrokerData.timezoneAbbr : 'America/New_York';
                        const date = new Date();
                        console.log("date", date);
                        const formatter = new Intl.DateTimeFormat('en-US', { timeZone: area });
                        const localDateString = formatter.format(date);

                        console.log("date in timezoneabr", localDateString)
                        console.log("type of endate", typeof (authBrokerData?.guest_end_date), "cur", typeof (localDateString), "date", typeof (date))
                        // const convertedGuestuser = formatter.format(authBrokerData?.guest_end_date);
                        // console.log("formatted end date",convertedGuestuser)

                        const inputDate = new Date(authBrokerData?.guest_end_date);

                        const options = {
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric',
                            timeZone: area, // Specify the target timezone here
                        };
                        const outputDateString = new Intl.DateTimeFormat('en-US', options).format(inputDate);
                        console.log("formatted end date", outputDateString);

                        let days = getDateDifference(localDateString, outputDateString);
                        console.log("diff", days);
                        if (days > 0) {
                            setdaysLeft(days);
                            setShowTrailAlert(true);
                        }

                    }
                }
            }
        }
    }, [authBroker]);

    function getDateDifference(startDate, endDate) {
        // Split the date strings into arrays [month, day, year]
        const startDateParts = startDate.split('/');
        const endDateParts = endDate.split('/');

        // Create Date objects (months are 0-based in JavaScript)
        const start = new Date(startDateParts[2], startDateParts[0] - 1, startDateParts[1]);
        const end = new Date(endDateParts[2], endDateParts[0] - 1, endDateParts[1]);

        // Calculate the difference in milliseconds
        const timeDifference = end - start;

        // Convert the difference to days
        const daysDifference = timeDifference / (1000 * 3600 * 24);

        return daysDifference;
    }

    const [isProfilePopup, setIsProfilePopup] = useState({
        isOpen: false,
        progress: 0
    })
    const [isOnBoardPopup, setIsOnBoardPopup] = useState({
        isOpen: false,
        progress: 0
    })
    const [isOnCheckListPopup, setIsOnCheckListPopup] = useState({
        isOpen: false,
        progress: 0
    })
    const [profilePercent, setProfilePercent] = useState(0)
    const [confirmModal, setConfirmModal] = useState(false)
    const [confirmMsgModal, setConfirmMsgModal] = useState(false)
    const [showModalMsg, setShowModalMsg] = useState('')

    const [bannerLoading, setBannerLoading] = useState(false)

    const [joyState, setJoyState] = useState({
        run: false,
        steps: [
            {
                content: <h2>Let's begin our journey!</h2>,
                locale: { skip: <strong aria-label="skip">skip</strong> },
                placement: 'center',
                target: 'body',
            },
            {
                target: '.mobclassfluid',
                content: 'This is my awesome feature!',
            },
        ],
    });


    useEffect(() => {
        if (userRole === "realtor" || userRole === "manager") {
            setTimeout(() => {
                dispatch(getBannerCardSummary({
                    module: 'bannerCardSummary',
                    postData: {
                        token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
                    }
                }))
            }, 1500)
        }
    }, [dispatch, userRole])

    // useEffect(() => {
    //     // console.log('imgData: ', authBroker)
    //     setTimeout(() => {
    //         dispatch(myCart({
    //             module: 'myCart',
    //             email: localStorage.getItem(SessionKeys.EMAIL_SESSION)
    //         }))
    //     }, 1000)
    // }, [auth])

    useEffect(() => {
        // console.log('bannerCard', bannerCard)
        if (!_.isEmpty(bannerCard)) {
            if (bannerCard.status === 'success') {
                const bannerData = bannerCard.payload?.payload
                if (!_.isEmpty(bannerData)) {
                    if (bannerData.onboarding.progress < 100) {
                        setIsOnBoardPopup({
                            isOpen: true,
                            progress: bannerData.onboarding.progress
                        })
                    } else {
                        setIsOnBoardPopup({
                            isOpen: false,
                            progress: 0
                        })
                    }
                    if (bannerData.profile.completion < 100) {
                        setIsProfilePopup({
                            isOpen: true,
                            progress: bannerData.profile.completion
                        })
                        setProfilePercent(bannerData.profile.completion)
                    } else {
                        setIsProfilePopup({
                            isOpen: false,
                            progress: 0
                        })
                    }
                    if (bannerData.checklist.progress < 100) {
                        setIsOnCheckListPopup({
                            isOpen: true,
                            progress: bannerData.checklist.progress
                        })
                    } else {
                        setIsOnCheckListPopup({
                            isOpen: false,
                            progress: 0
                        })
                    }
                }
            } else if (bannerCard.status === 'error') {
                setIsOnBoardPopup(false)
                setIsOnCheckListPopup(false)
                setIsProfilePopup(false)
            }
            setBannerLoading(true)
            // dispatch(getBannerCardSummaryClear())
        }
    }, [bannerCard])

    useEffect(() => {
        if (isMembershipSucceed) {
            setConfirmModal(true)
            setTimeout(() => {
                dispatch(setIsMembershipClear())
            }, 10000)
        }
    }, [isMembershipSucceed])


    useEffect(() => {
        if (showHomePageMsg && homePageMsg) {
            window.scrollTo(0, 0)
            setConfirmMsgModal(true)
            setShowModalMsg(homePageMsg)
            setTimeout(() => {
                dispatch(homePageShowMsg(false))
                dispatch(homePageMsgClear(''))
                setConfirmMsgModal(false)
                setShowModalMsg('')
            }, 10000)
        }
    }, [showHomePageMsg, homePageMsg])

    const handleClickStart = (event) => {
        event.preventDefault();
        console.log('start joyride');
        setJoyState({
            run: true,
            steps: [
                {
                    content: <h2>Let's start your journey!</h2>,
                    locale: { skip: <strong aria-label="skip">Skip</strong> },
                    placement: 'center',
                    target: 'body',
                },
                {
                    target: '#myDashboard',
                    placement: 'top',
                    title: 'My Dashboard',
                    content: 'Get access to insights like learning points and rank!',
                    locale: { skip: <strong aria-label="skip">Skip</strong> },
                },
                {
                    target: '#myCalendar',
                    placement: 'top',
                    title: 'My Calendar',
                    content: 'You can see your weekly sessions.',
                    locale: { skip: <strong aria-label="skip">Skip</strong> },
                },
                {
                    target: '#myArea',
                    placement: 'top',
                    title: 'My Area',
                    content: 'You can see all the assigned courses & learning paths and your learning progress.',
                },
            ]
        });
    };

    const handleJoyrideCallback = (data) => {
        console.log(data)
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            setJoyState({
                run: false, steps: [
                    {
                        content: <h2>Let's start your journey!</h2>,
                        locale: { skip: <strong aria-label="skip">Skip</strong> },
                        placement: 'center',
                        target: 'body',
                    },
                    {
                        target: '#myDashboard',
                        placement: 'top',
                        title: 'My Dashboard',
                        content: 'Get access to insights like learning points and rank!',
                        locale: { skip: <strong aria-label="skip">Skip</strong> },
                    },
                    {
                        target: '#myCalendar',
                        placement: 'top',
                        title: 'My Calendar',
                        content: 'You can see your weekly sessions.',
                        locale: { skip: <strong aria-label="skip">Skip</strong> },
                    },
                    {
                        target: '#myArea',
                        placement: 'top',
                        title: 'My Area',
                        content: 'You can see all the assigned courses & learning paths and your learning progress.',
                    },
                ]
            });
        }
    };

    const renderAlertCard = () => {
        return (
            <div className={`alert-card d-flex justify-content-center premimimmember ${confirmModal ? '' : 'd-none'}`}>
                <div className="premium-band">
                    <div className="shop-info justify-content-center align-items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                            <g id="Group_5699" data-name="Group 5699" transform="translate(0.498 0.498)">
                                <circle id="Ellipse_222" data-name="Ellipse 222" cx="9" cy="9" r="9" transform="translate(-0.498 -0.498)" fill="#A9C23C" />
                                <path id="Icon_material-done" data-name="Icon material-done" d="M9.712,16.558,7.79,14.88l-.9.9L9.712,18.35l6.425-6.657-.9-.9Z" transform="translate(-3.013 -6.071)" fill="#fff" stroke="#fff" strokeWidth="2" />
                            </g>
                        </svg>
                        <p className="m-0">
                            Congratulations! Your account has been upgraded to Xsel Premium membership.
                        </p>
                    </div>
                    <div className="view-cart-icon">
                        <span
                            className="cursor-pointer"
                            onClick={() => {
                                clickStreamUser('go-to-myorder-from-band', {
                                    userId: auth.authBroker?.payload.user.user_id,
                                })
                                navigate('/orders')
                            }}
                        >View Order Details</span>
                        <i className="fa fa-times cursor-pointer" aria-hidden="true"
                            onClick={() => {
                                setConfirmModal(false)
                            }}
                        ></i>
                    </div>
                </div>
            </div>
        )
    }

    const renderCard = () => {
        return (
            <div className={`alert-card d-flex justify-content-center homealertbox ${confirmMsgModal ? '' : 'd-none'}`}>
                <div className="shop-cart">
                    <div className="shop-info justify-content-center">
                        <p className="m-0">{showModalMsg}</p>
                    </div>
                    <div className="view-cart-icon">
                        <i className="fa fa-times cursor-pointer" aria-hidden="true"
                            onClick={() => {
                                setConfirmMsgModal(false)
                                dispatch(homePageShowMsg(false))
                                dispatch(homePageMsgClear(''))
                                setShowModalMsg('')
                            }}
                        ></i>
                    </div>
                </div>
            </div>
        )
    }

    const renderBannerCard = () => {
        return (
            <div className="slider-card" >
                <div className="container">
                    {
                        bannerLoading ?
                            <div className="row">
                                {isProfilePopup.isOpen ?
                                    <div className="card popup-home">
                                        <div className="card-body">
                                            <div className="popup-home-pg">
                                                <div className="container-chart chart-section">
                                                    <div className="box d-flex align-items-center justify-content-center pie-chart">
                                                        <div className='circularProgress'
                                                            style={{
                                                                width: 56,
                                                                height: 56,
                                                                position: "relative"
                                                            }}
                                                        >
                                                            <CircularProgressbar
                                                                value={72}
                                                                styles={buildStyles({
                                                                    pathColor:
                                                                        72 < 100 ? `#7A549E` : "#6CC869",  //FF9700=yellow
                                                                    trailColor: "#EBEBEB",
                                                                })}
                                                            />
                                                            <div style={{
                                                                position: "absolute",
                                                                top: "0.5rem",
                                                                left: "0.5rem",
                                                                width: "40px",
                                                                textAlign: "center"
                                                            }}>
                                                                <ReactRoundedImage
                                                                    image={authBroker?.payload?.user?.profile_img !== undefined && authBroker?.payload?.user?.profile_img !== '' ?
                                                                        authBroker?.payload?.user?.profile_img : "/images/avatar.svg"}
                                                                    roundedSize="0" imageWidth="40" imageHeight="40"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="progress-content">
                                                            <p>{isProfilePopup.progress}% </p>
                                                            <p>complete</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p className="card-text">You are a minute away from completing your Profile</p>
                                                <p className="text-center">
                                                    <button type="button" className="btn btn-primary-complete"
                                                        onClick={() => {
                                                            clickStreamUser('click-profile-complete-btn', {
                                                                user_id: authBroker?.payload?.user?.user_id,
                                                            })
                                                            navigate(`/profile/edit?section=edit&user_id=${localStorage.getItem(SessionKeys.USER_ID)}&tab=1`)
                                                        }
                                                        }>Complete Profile</button>
                                                </p>
                                                <p className="content-remind cursor-pointer" onClick={() => {
                                                    clickStreamUser('click-remind-me-later-btn', {
                                                        user_id: authBroker?.payload?.user?.user_id,
                                                    });
                                                    localStorage.setItem(SessionKeys.REMIND_ME_LATER, true);
                                                    setIsProfilePopup(false)
                                                }}>Remind me later</p>
                                            </div>
                                        </div>
                                    </div> : ""}

                                {isOnBoardPopup.isOpen ? <div className="card popup-home02">
                                    <div className="card-body">
                                        <div className="popup-home-pg">
                                            <div className="container-chart chart-section">
                                                <div className="box d-flex align-items-baseline justify-content-center oboardg_pop_icon">
                                                    <img src="images/Group 5121.png" alt="" />

                                                </div>
                                            </div>
                                            <h5 className="card-text_onbordng">Onboarding</h5>
                                            <p className="card-text">Welcome aboard!<br /> Start your journey here</p>

                                            <p className="text-center">
                                                <button type="button" className="btn btn-primary-startNow" onClick={() => {
                                                    clickStreamUser('click_start_now_onboarding_btn', {
                                                        user_id: authBroker?.payload?.user?.user_id,
                                                    })
                                                    console.log("test---",document.getElementById("myOnboard-div"))
                                                    if(document.getElementById("myOnboard-div")) {
                                                    document.getElementById("myOnboard-div").scrollIntoView();
                                                    }
                                                }}>
                                                    {isOnBoardPopup.progress === 0 ? 'Start Now' : 'Continue'}</button>
                                            </p>
                                            <p className="content-SkipExplore cursor-pointer" onClick={() => {
                                                clickStreamUser('click-skip-onboarding-btn', {
                                                    user_id: authBroker?.payload?.user?.user_id,
                                                })
                                                setIsOnBoardPopup(false)
                                            }}>Skip and explore</p>
                                        </div>
                                    </div>
                                </div> : ""
                                }
                                {isOnCheckListPopup.isOpen ? <div className="card popup-home03">
                                    <div className="card-body">
                                        <div className="popup-home-pg">
                                            <div className="container-chart chart-section">
                                                <div className="box d-flex align-items-baseline justify-content-center oboardg_pop_icon">
                                                    <img src="images/Group 5121.png" alt="" />

                                                </div>
                                            </div>
                                            <h5 className="card-text_onbordng">Code Of Ethics</h5>
                                            <p className="card-text">Review and submit your Code Of Ethics here</p>

                                            <p className="text-center">
                                                <button type="button" className="btn btn-primary-startNow" onClick={() => {
                                                    clickStreamUser('click-start-now-checklist-btn', {
                                                        user_id: authBroker?.payload?.user?.user_id,
                                                    })
                                                    // document.getElementById("myOnboard").scrollIntoView()
                                                    navigate('/codeOfEthics')
                                                }}>
                                                    {isOnCheckListPopup.progress === 0 ? 'Start Now' : 'In Progress'}
                                                </button>
                                            </p>
                                            <p className="content-SkipExplore cursor-pointer" onClick={() => {
                                                clickStreamUser('click-skip-code-of-ethics-btn', {
                                                    user_id: authBroker?.payload?.user?.user_id,
                                                })
                                                localStorage.setItem(SessionKeys.REMIND_ME_LATER, true);
                                                setIsOnCheckListPopup(false)
                                            }}>Remind me later</p>
                                        </div>
                                    </div>
                                </div> : ""}
                            </div>
                            :
                            <div className="row">
                                {
                                    [1, 2].map(n => {
                                        return (
                                            <ShimmerBannerCard />
                                        )
                                    })
                                }
                            </div>
                    }
                </div>
            </div>
        )
    }

    return (
        <>

            {/*<Joyride
                    callback={handleJoyrideCallback}
                    continuous
                    hideCloseButton
                    run={joyState.run}
                    scrollToFirstStep
                    showProgress
                    showSkipButton
                    steps={joyState.steps}
                    styles={{
                        options: {
                            zIndex: 10000,
                        },
                    }}
                />*/}
            <section className="bannermodule">
               {userRole === "instructor" ? "" : <> <BannerSection
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                /> 
                {renderAlertCard()}
                {renderCard()}
                {/*<AttentionModal isShow={true}/>*/}
                {userRole === "instructor" || userRole === "host" ? (
          ""
        ) :renderBannerCard()} </>}
            </section>
            <MainSection
                startJoyRide={handleClickStart}
            />

            {showTrailAlert ? <div className="alert-card d-flex justify-content-center trial-licence-popup">
                <div className="shop-cart">
                    <div className="shop-info justify-content-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
                        <path d="M23.7526 18.5469L13.7682 1.48438C13.3463 0.828125 12.69 0.5 12.0338 0.5C11.3307 0.5 10.6744 0.828125 10.2526 1.48438L0.221349 18.5469C-0.481776 19.8594 0.455729 21.5 2.0026 21.5H22.0182C23.5651 21.5 24.5026 19.8594 23.7526 18.5469ZM2.47135 19.25L11.9869 2.98438L21.5494 19.25H2.47135ZM12.0338 14.8438C11.19 14.8438 10.5338 15.5 10.5338 16.2969C10.5338 17.0938 11.19 17.75 12.0338 17.75C12.8307 17.75 13.4869 17.0938 13.4869 16.2969C13.4869 15.5 12.8307 14.8438 12.0338 14.8438ZM10.9088 7.625V12.125C10.9088 12.7812 11.3776 13.25 12.0338 13.25C12.6432 13.25 13.1588 12.7812 13.1588 12.125V7.625C13.1588 7.01562 12.6432 6.5 12.0338 6.5C11.3776 6.5 10.9088 7.01562 10.9088 7.625Z" fill="#2d2d2d"/>
                    </svg>
                        <p className="m-0"> Your trial licence is expiring in {daysLeft} days</p>
                    </div>
                    <div className="view-cart-icon">
                        <i className="fa fa-times cursor-pointer" aria-hidden="true" onClick={() => setShowTrailAlert(false)}></i>
                    </div>
                </div>
            </div> : ""}
        </>
    )
}

export default HomeSection